<div class="card rdo-card rdo-card-default">
    <div class="rate-type-card-header card-header">
        <div class="rate-type-card-title card-title ellipsed">
            <i class="fa fa-calendar"></i>&nbsp;
            {{titleName | translate}} {{titleValue | rdoCurrency:true:translateService.currentLang}} {{'main.core.common.total' | translate}}
        </div>
    </div>
    <div class="card-body cell-container">
        <div class="cell">
            <div class="title two-lined-ellipsed">
                {{subTitleName | translate}}
            </div>
            <div class="data rdo-card-metric">
                <span [ngClass]="{'text-danger': firstValue < 0, 'text-muted': firstValue === 0 }">
                    {{firstValue | rdoCurrency:undefined:translateService.currentLang}}
                </span>
            </div>

        </div>
        <div class="cell right">
            <div class="title two-lined-ellipsed">
                {{differenceTitle | translate}}
            </div>
            <div class="data rdo-card-metric">
                <rdo-amount-difference [clientValue]=firstValue [benchmarkedValue]=secondValue [showCurrencySymbol]=true>
                </rdo-amount-difference>
            </div>
        </div>
    </div>
</div>
